
import { DEFAULT_SCOPE_REQUIRES, SCOPE_SOURCES } from '@app/scope/sources'
import { getScopeHomePath, resolveScope } from '@shared/lib/scope'
import { resolveSourceId } from '@shared/lib/scope'
import { sourceStartMode } from '@shared/lib/scope'
import { useDisciplineStore } from '@entities/customer'
import { useCustomerStore } from '@entities/customer'
import { show404 } from '@shared/lib/page-error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to, from) => {
  const customerStore = useCustomerStore()
  const disciplineStore = useDisciplineStore()

  const target = resolveScope(to, customerStore.customer)
  if (!target) return show404()

  const { changed } = disciplineStore.setScope(target)

  const homePath = getScopeHomePath(target)
  const needsSubjectHome = !disciplineStore.activeDiscipline
    && !to.meta.scope?.allowsMissingSubject
    && to.path !== homePath
  if (needsSubjectHome) return navigateTo(homePath, { replace: true })

  const disciplineId = disciplineStore.activeDiscipline?.id ?? null
  const requires = to.meta.scope?.requires ?? DEFAULT_SCOPE_REQUIRES
  const loads = to.meta.scope?.loads ?? []

  const startedSources = [...requires, ...loads]
  const isSamePage = to.path === from.path

  startedSources.forEach((source) => {
    const definition = SCOPE_SOURCES[source]
    const id = resolveSourceId(definition.param, to.params, disciplineId)
    if (id === null) return

    const mode = sourceStartMode(definition, definition.status(id), { changed, isSamePage })
    if (mode) definition.start(id, mode)
  })
})
